export class MarkerUtils{

    public static getPosition(Point: google.maps.Data.Feature): google.maps.LatLng{
        var lat: number = 0;
        var lng: number = 0;

        try{
            lat = Point.getProperty("Lat");
            lng = Point.getProperty("Long");
        }
        catch(e){
            // console.log(e);
            e.toString();
        }
        
        return new google.maps.LatLng({lat: lat, lng: lng});
    }

    public static getVisible(Point: google.maps.Data.Feature){
        return true;
    }

    //
    // Used to show or hide a point (pass null map to hide)
    // NOTE: Have to include a reference to the map in each point
    //       (Might look into changing this, ex. Single static map reference, 
    //       or just store pointer to dictionary of maps if there's multiple pages using it?)
    //
    public static setMap(Point: google.maps.Data.Feature, map: google.maps.Map | null){
        if(map != null){
            map.data.add(Point);
        }
        else{
            var mainMap = Point.getProperty("Map") as google.maps.Map;

            mainMap.data.remove(Point);
        }
    }

}